<template lang="pug">
  v-layout(column flat)
    v-subheader(v-if="item.optionList.length > 0") {{item.title}}
    v-card.menu(  v-for="(optionItem, idx) in item.optionList" :key="idx")
      offer-list-item-option(:item="optionItem" :subGroupTags="item.tags"
        :tagCollection="tagCollection" :itemCollection="itemCollection" :allergensList="allergensList" :keyList="keyList" @update="updateData")

</template>

<script lang="ts">
import Vue from 'vue'
import MenuGroupItem from '@/model/dailymenu/MenuGroupItem'
import OfferListItemOption from '@/components/dailymenu/detail/OfferListItemOption.vue'
import {Component, Prop} from "vue-property-decorator";
import Tag from "@/model/tennant/Tag";
import FoodItem from "@/model/food-database/FoodItem";
import Allergen from "@/model/food-database/Allergen";
import KeyList from "@/model/KeyList";
import {Action} from "vuex-class";
import {FETCH_KEY_BY_ID} from "@/store/action-types";

@Component({
  components: {
    OfferListItemOption,
  }
})
export default class OfferListItemSelector extends Vue {

  @Prop({type: Object as () => MenuGroupItem}) item!: MenuGroupItem
  @Prop({type: Array as () => Tag[]}) tagCollection!: Tag[]
  @Prop({type: Array as () => FoodItem[]}) itemCollection!: FoodItem[]
  @Prop({type: Array as () => Allergen[]}) allergensList!: Allergen[]
  @Action(FETCH_KEY_BY_ID) fetchBusinessKey!: { (): Promise<KeyList[]> }

  private keyList: KeyList[] | null = null
  private business: any[] | null = null

  updateData() {
    this.$emit('update')
  }

  async fetchKey():Promise<void> {

    try {
      this.keyList = await this.fetchBusinessKey()
    } catch (e) {
    }
  }

  mounted() {
    this.fetchKey()
  }
}
</script>

<style lang="stylus" scoped>

.menu
  margin: 10px;

</style>
